import { useContext, useEffect } from 'react';
import UserContext from '../../library/UserContext';
import { LoadingSpinner } from '@uhg-eis/crimsonai-react-components';

const Logout = () => {
  const { logout } = useContext(UserContext);
  useEffect(() => {
    logout();
  }, []);

  return <LoadingSpinner size={'l'} loading={true} loadingText='Signing out, please wait...' />;
};

export default Logout;
